// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__29aiN","right":"styles_right__3p1JH"};